import { API } from '@/api';

export const classes = {
  wrapper: 'place-center size-full',
  logoRow: 'flex justify-center',
  logoWide: 'mb-[44px]',
  logoTight: 'mb-6',
};

export function fetchSessionUser() {
  return API.Users.fetchCurrentUser();
}
